import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CommonLoading from "./CommonLoading";
import { Box, Image, Skeleton, useColorModeValue } from "@chakra-ui/react";
import { COMMON_ALT } from "../../constant";
import useDomainConfig from "../../hook/useDomainConfig";

const LazyImage = ({
  src,
  alt,
  className,
  fetchPriority,
  onError,
  isPromotion,
}) => {
  const [loaded, setLoaded] = useState(false);

  const bgColor = useColorModeValue("#8213f0", "dark.100");

  const { mainLogoUrl } = useDomainConfig();

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoaded(true);
  //   }, 500);
  // }, []);
  // CommonLoading isLoaded={loaded}
  return (
    <>
      <LazyLoadImage
        src={src}
        alt={alt}
        onLoad={() => {
          setLoaded(true);
        }}
        onError={onError}
        fetchpriority={fetchPriority}
        className={`${className}`}
      />
      {!loaded && (
        <Box
          position="absolute"
          top="0px"
          left="0px"
          bg={bgColor}
          zIndex={0}
          w="100%"
          h="100%"
          display={`flex`}
          alignItems={`center`}
          justifyContent={`center`}
          borderTopRadius={`common`}
        >
          <Image
            src={mainLogoUrl}
            cursor={"pointer"}
            w="120px"
            objectFit={`cover`}
            mb={isPromotion && "100px"}
            pointerEvents={"all"}
            alt={COMMON_ALT}
            filter="grayscale(100%)"
          />
        </Box>
      )}
    </>
  );
};

export default React.memo(LazyImage);
